<template>
  <v-dialog v-model="isPopup" max-width="720" persistent>
    <v-card>
      <!-- 상단 제목 -->
      <v-card-title class="headline font-weight-bold justify-center">
        SK스페셜티 방문예약시스템 접속 주소 변경을 안내드립니다.
        <br>(아래 두가지 방법으로 접속 가능)
      </v-card-title>

      <div class="mt-6"></div>

      <!-- 본문 내용 -->
      <v-card-text class="text-subtitle-1" style="color:#222; line-height: 2;">
        <div>
          - <a href="https://visit.skspecialty.com/" target="_blank" class="blue--text text-decoration-underline">https://visit.skspecialty.com/</a> 좌측 링크 클릭 (신규 SK스페셜티 방문예약시스템)
        </div>
        <div>
          - SK스페셜티 홈페이지 (<a href="https://www.skspecialty.com/" target="_blank" class="blue--text text-decoration-underline">https://www.skspecialty.com/</a>) 접속 후 최 하단부 '방문접수' 클릭
        </div>
        <div class="mt-3" style="font-size: 13px;">
         문의 : SK스페셜티 보안실 (Tel : 054-630-8127)
        </div>
      </v-card-text>

      <!-- 오늘 하루 보지 않기 + 닫기 -->
      <v-card-actions>
        <v-checkbox
          v-model="isChecked"
          label="오늘 하루 보지 않기"
          hide-details
          @click="onCloseDayNot"
          class="mt-n1"
        />
        <v-spacer></v-spacer>
        <v-btn text color="grey darken-2" @click="Close"><v-icon class="mr-1">mdi-close-box</v-icon>닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      isPopup: false,
      isChecked: false,
    };
  },
  mounted() {
    this.getPOP();
  },
  methods: {
    getPOP() {
      const today = new Date().toISOString().split("T")[0];
      const closedDate = localStorage.getItem("popupClosedDate");

      // 오늘 하루 보지 않기 체크 안했으면 팝업 열기
      if (closedDate !== today) {
        this.isPopup = true;
      }
    },
    onCloseDayNot() {
      const today = new Date().toISOString().split("T")[0];
      localStorage.setItem("popupClosedDate", today);
      this.Close();
    },
    Close() {
      this.isPopup = false;
    }
  }
};
</script>
